import { createBrowserRouter } from "react-router-dom";
import { AppLayout } from "@/components/layout/AppLayout";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { LandingPage } from "@/pages/LandingPage";
import { PreviewPage } from "@/pages/PreviewPage";
import { CallbackPage } from "@/pages/CallbackPage";
import { DashboardPage } from "@/pages/DashboardPage";
import { TrackerPage } from "@/pages/TrackerPage";
import { TeamsPage } from "@/pages/TeamsPage";
import { ProjectsPage } from "@/pages/ProjectsPage";
import { ClientsPage } from "@/pages/ClientsPage";
import { AccountPage } from "@/pages/AccountPage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <LandingPage />,
  },
  {
    path: "/preview",
    element: <PreviewPage />,
  },
  {
    path: "/callback",
    element: <CallbackPage />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppLayout />,
        children: [
          { path: "/dashboard", element: <DashboardPage /> },
          { path: "/tracker", element: <TrackerPage /> },
          { path: "/teams", element: <TeamsPage /> },
          { path: "/projects", element: <ProjectsPage /> },
          { path: "/clients", element: <ClientsPage /> },
          { path: "/account", element: <AccountPage /> },
        ],
      },
    ],
  },
]);
